// Vision Super

// Make sure any image references are for images located in "public/img"

export default {
  settings: {
    disableIframePostMessage: false,
  },

  defaults: {
    age: 30,
    insuranceType: "deathTPD",
    coverAmount: 1000000
  },

  content: {
    general: {
      websiteUrl: "https://www.visionsuper.com.au/",
      modellerName: "Death and Total & Permanent Disability (TPD) Cover Calculator",

      tabLabels: {
        welcomeTab: "Welcome",
        calculationTab: "Get a quote",
        whatsNextTab: "What's next?",
      },

      disclaimer: `<p>
      This calculator has been provided to you by Vision Super Pty Ltd. The estimate produced by this calculator is based on 
      details you enter and can assist to work out the cost of insurance for Vision Super Saver members from 1 October 2024. 
      It does not apply to Super Saver ASU or Vision Super Personal members. For information about our insurance cover, 
      including its terms and conditions, refer to the Insurance Guides which are available on our website. Please note that 
      this calculator is for illustrative purposes only. Although Vision Super endeavours to ensure that the calculations are 
      accurate, we cannot guarantee its accuracy or accept liability for any errors or omission. If you make any changes to your 
      insurance cover it may be subject the provision of medical evidence. You have the option to change, review or cancel your 
      insurance at any time. Before making any financial decisions consider your own financial circumstances, needs and 
      objectives and we recommend you seek professional financial advice and consider the relevant Product Disclosure Statement and Target Market Determination.</p>
      <p>Any personal information collected by this calculator will be treated in accordance with our Privacy Policy and Privacy Collection Statement.</p>`,
    },

    welcome: {
      bannerHeading: `<h1>Death and TPD Cover</h1>`,
      header: `<h3>Do I need Death and Total &amp; Permanent Disability (TPD) Cover?</h3>`,
      content: `<br />
      <p>It's something we don't often like to think about, but it's inevitable that one day, we'll no longer be around. 
      A death in the family can place financial strain on the family, so with death cover a lump sum will be paid out and 
      can help your loved ones cover funeral costs and ongoing living expenses.</p>
      <p>This cover can also come with Total and permanent disability (TPD). A permanent injury or illness can make it 
      difficult and sometimes impossible to return work. In that situation, if you have TPD cover it can help provide a 
      financial safety net to support you and your family, and pay for medical and rehabilitation costs. It is usually 
      paid as a one-off, lump sum payment.</p>
      <br />`,
      buttonLabel: "CONTINUE",
    },

    calculation: {
      header: "Death and Total &amp; Permanent Disability (TPD) cover provides you or your beneficiaries with a benefit if you die or become permanently disabled.",
      resultsIntro: "Two ways to get",

      deathOnlyButtonLabel: `<span class="lg-text">Death cover</span><br />only`,
      deathTpdButtonLabel: `<span class="lg-text">Death &amp; TPD</span><br />cover`,

      ageBasedCoverHeading: "Age Based Cover",
      ageBasedCoverText: `With Aged Based Cover your premium remains the same and your cover comes down with age. This calculator has allocated the minimum number of units (based on your age) to meet your requested cover and rounded the cover to provide you with whole units.`,
      ageBasedCoverCoverLabel: "Cover:",
      ageBasedCoverCostLabel: "Cost:",
      ageBasedCoverPerPeriod: `<br/>per week`,
      ageBasedCoverTableColPerPeriod: "Per week",
      
      fixedCoverHeading: "Fixed Cover",
      fixedCoverText: `With Fixed Cover your premium goes up and your cover remains the same with age. This calculator has rounded your requested cover to the nearest $1,000.`,
      fixedCoverCoverLabel: "Cover:",
      fixedCoverCostLabel: "Cost:",
      fixedCoverPerPeriod: `<br/>per week`,
      fixedCoverTableColPerPeriod: "Per week",
      
      yoyChangesHeading: "Year on year changes",

      ageLabel: "Your age",
      insuranceTypeLabel: "Type of insurance",
      coverAmountLabel: "Amount of cover",

      insuranceTypeTooltip: "Death and Total &amp; Permanent Disability (TPD) Cover provides you with a lump sum benefit if you die or are totally and permanently disabled. Death cover only provides your family or estate with a lump sum benefit if you die.  Please refer to the applicable Vision Super PDS for more information.",
      coverAmountTooltip: "This includes living expenses such as bills and groceries, educational costs for your dependents, a lump sum amount to cover your funeral and medical costs, etc. Remember to also take into account any existing insurance cover as well as your available savings.",

      calculateButtonLabel: "CALCULATE",
      printButtonLabel: "PRINT",
      reCalculateButtonLabel: "RE-CALCULATE",
      nextButtonLabel: "NEXT",
    },

    whatsnext: {
      heading: `<h2 class="whats-next-title">We're with you<br>every step of the way</h2>`,
      leftColContent: `<div class="cta-box light-red">
        <div class="cta-icon">
          <img src="img/vision-super/red-hand.png" alt="Apply now">
        </div>
        <div class="cta-title">
          <h4>
            Apply <br>today
          </h4>
        </div>
        
        <p>
          We know that things change, so we’ve made it as simple as possible for you to update, cancel or apply 
          for insurance cover that suits your situation. Log into our member secure portal and apply today.   
        </p>
        <a
          color="primary"
          class="btn btn-primary"
          tag="a"
          href="https://visiononline.visionsuper.com.au/aol/index.html#MemberLogin"
        >
          Apply today 
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.90602 0.000242082C5.95676 0.00194012 4.07572 0.715239 2.61883 2.00518C1.16193 3.29512 0.230227 5.07222 0 7.00024H8.72172L6.40011 4.68774L7.84327 3.25024L12.5492 8.00024L7.84327 12.6877L6.40011 11.2502L8.72172 9.00024H0C0.193583 10.5304 0.827053 11.9721 1.82415 13.152C2.82124 14.3318 4.13945 15.1994 5.62007 15.6504C7.10069 16.1013 8.68062 16.1164 10.1696 15.6937C11.6586 15.271 12.9933 14.4287 14.0128 13.268C15.0324 12.1074 15.6934 10.678 15.9163 9.15181C16.1392 7.62567 15.9145 6.06787 15.2693 4.66596C14.624 3.26406 13.5857 2.07781 12.2793 1.25004C10.973 0.422263 9.45426 -0.0117532 7.90602 0.000242082Z" fill="#fff" style="fill : #undefined !important;"></path> </svg>
        </a>
      </div>`,
      rightColContent: `<div class="cta-box light-navy">
        <div class="cta-icon">
          <img src="img/vision-super/contact-us.png" alt="Apply now">
        </div>
        <div class="cta-title">
          <h4>
            We're here<br>to help
          </h4>
        </div>
        <p>
          If you're unsure about what cover is right for you or how much you will need, we're here to help.
        </p>
        <a
          color="primary"
          class="btn btn-primary"
          tag="a"
          href="https://www.visionsuper.com.au/contact-us/"
        >
          Contact us 
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.90602 0.000242082C5.95676 0.00194012 4.07572 0.715239 2.61883 2.00518C1.16193 3.29512 0.230227 5.07222 0 7.00024H8.72172L6.40011 4.68774L7.84327 3.25024L12.5492 8.00024L7.84327 12.6877L6.40011 11.2502L8.72172 9.00024H0C0.193583 10.5304 0.827053 11.9721 1.82415 13.152C2.82124 14.3318 4.13945 15.1994 5.62007 15.6504C7.10069 16.1013 8.68062 16.1164 10.1696 15.6937C11.6586 15.271 12.9933 14.4287 14.0128 13.268C15.0324 12.1074 15.6934 10.678 15.9163 9.15181C16.1392 7.62567 15.9145 6.06787 15.2693 4.66596C14.624 3.26406 13.5857 2.07781 12.2793 1.25004C10.973 0.422263 9.45426 -0.0117532 7.90602 0.000242082Z" fill="#fff" style="fill : #undefined !important;"></path> </svg>
        </a>
      </div>`,
    },
  },

  api: {
    platformId: "f2fde71ccd1c4e878c78f5bf4bbdbc0f",
    devJwt: "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJWUy1JUS1CQy1ERVYiLCJ1Ijp7fSwiaWF0IjoxNzIxNjk4NDc3LCJyb2xlcyI6WyJCcm93c2VyQ2xpZW50Il19.qu7diXEcm1hyMJzsEpocG7s9hLNhT32wj9mATe01-SE",
    prdJwt: "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJWUy1JUS1CQyIsInUiOnt9LCJpYXQiOjE3MjE3MDk4MjEsInJvbGVzIjpbIkJyb3dzZXJDbGllbnQiXX0.491qpgV0ad4X8VA2iTwi7-2goPUcG4i5tPwJvg2v-MY"
  },

  analytics: {
    gacode: "G-KPN68R32XK"
  },

  insurancePremiumData: {
    quoteData: {
      unitCover: {
        deathOnlyPremium: 0.74,
        deathTPDPremium: 1.72,
      },
    },
  
    params: {
      calculationMethod: 'visionsuper',
      minAge: 15,
      maxAge: 69,

      minSalary: 8000,
      maxSalary: 360000,
      salaryStep: 2000,

      costDeathOnly: 0.62,
      minDeathOnly: 8000,
      maxDeathOnly: 5000000,
      
      costDeathTPD: 1.43,
      minDeathTPD: 8000,
      maxDeathTPD: 2500000
    },
    lastUpdated: "July 2024"
  }
};